//# sourceMappingURL=admin_automations.mjs.map
/// <reference types="./admin_automations.d.mts" />
import { Ok, Error, CustomType as $CustomType } from "../gleam.mjs";

export class QuestionBank extends $CustomType {}
export const ExportType$QuestionBank = () => new QuestionBank();
export const ExportType$isQuestionBank = (value) =>
  value instanceof QuestionBank;

export class Sources extends $CustomType {}
export const ExportType$Sources = () => new Sources();
export const ExportType$isSources = (value) => value instanceof Sources;

export class FixLegacyWordProposals extends $CustomType {}
export const AutomationButtonType$FixLegacyWordProposals = () =>
  new FixLegacyWordProposals();
export const AutomationButtonType$isFixLegacyWordProposals = (value) =>
  value instanceof FixLegacyWordProposals;

export class ReRunInsights extends $CustomType {}
export const AutomationButtonType$ReRunInsights = () => new ReRunInsights();
export const AutomationButtonType$isReRunInsights = (value) =>
  value instanceof ReRunInsights;

export class ReIngestData extends $CustomType {}
export const AutomationButtonType$ReIngestData = () => new ReIngestData();
export const AutomationButtonType$isReIngestData = (value) =>
  value instanceof ReIngestData;

export class SyncPgAndWeaviate extends $CustomType {}
export const AutomationButtonType$SyncPgAndWeaviate = () =>
  new SyncPgAndWeaviate();
export const AutomationButtonType$isSyncPgAndWeaviate = (value) =>
  value instanceof SyncPgAndWeaviate;

export class ProposalsMetrics extends $CustomType {}
export const AutomationButtonType$ProposalsMetrics = () =>
  new ProposalsMetrics();
export const AutomationButtonType$isProposalsMetrics = (value) =>
  value instanceof ProposalsMetrics;

export class ReRunProposal extends $CustomType {}
export const AutomationButtonType$ReRunProposal = () => new ReRunProposal();
export const AutomationButtonType$isReRunProposal = (value) =>
  value instanceof ReRunProposal;

export class WeaviateMigration extends $CustomType {}
export const AutomationButtonType$WeaviateMigration = () =>
  new WeaviateMigration();
export const AutomationButtonType$isWeaviateMigration = (value) =>
  value instanceof WeaviateMigration;

export function to_string(export_type) {
  if (export_type instanceof QuestionBank) {
    return "question_bank";
  } else {
    return "sources";
  }
}

export function from_string(export_type) {
  if (export_type === "question_bank") {
    return new Ok(new QuestionBank());
  } else if (export_type === "sources") {
    return new Ok(new Sources());
  } else {
    return new Error(undefined);
  }
}

export function encode_automation_button_type(automation_button_type) {
  if (automation_button_type instanceof FixLegacyWordProposals) {
    return "fix_legacy_word_proposals";
  } else if (automation_button_type instanceof ReRunInsights) {
    return "re_run_insights";
  } else if (automation_button_type instanceof ReIngestData) {
    return "re_ingest_data";
  } else if (automation_button_type instanceof SyncPgAndWeaviate) {
    return "sync_pg_and_weaviate";
  } else if (automation_button_type instanceof ProposalsMetrics) {
    return "proposal_metrics";
  } else if (automation_button_type instanceof ReRunProposal) {
    return "re_run_proposal";
  } else {
    return "weaviate_migration";
  }
}
